import React, { useEffect, useState } from 'react';
import { Grid } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import { getBlueprintDetails } from "../../../store/global/selectors";
import CreateBlueprintBackup from './CreateBlueprintBackup'
import BackupRestore from '../../pages/backupRestore';
import { getDetailsFromUrl } from '../../../services/blueprint';
import { invokeGetService } from '../../../store/global/actions';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';

const backupLocations = [
  { value: 'S3', label: 'Hyperblox cloud storage' },
  { value: 'git_repo', label: 'Your git repository' }
]

export default function RestoreBlueprint({ onClose, id, onCompletion }) {
    const dispatch = useDispatch()
    const blueprintId = useSelector(getBlueprintDetails)?._id;
    const [clearAlert, setClearAlert] = useState(false);
    const {screen} =  getDetailsFromUrl();
    const [loading, setLoading] = useState(false);
    const [gitConfiguration, setGitConfiguration] = useState(null);
    const browserTabTitle = screen === "teams" ? "Team" : screen === "assets" ? "Assets" : screen === "system-model" ?  "System Model" : screen === "transaction" ? "Transaction" : screen === "testsuite" ? "Simulation" : screen === "view" ? "View" : "Blueprint" ;

    useEffect(() => {
        setLoading(true);
      
        dispatch(invokeGetService('getGitConfiguration', {}))
          .then(response => {
            if (response?.status && response?.data !== null) {
              setGitConfiguration(response?.data);
            }
            setLoading(false);
          });
      
      }, [blueprintId]);

    return (
        loading ? <>
            <LoaderWithProgress size={12} styleRoot={{height: '40vh', width: '100%'}} isContent={true} isLoader={true}/>
        </> : 
        <Grid container direction={"row"} spacing={3} >

            {<Grid item xs={12} style={{ margin: '0px 25px', paddingBottom: 0 }}>
                <CreateBlueprintBackup backupLocations={backupLocations} gitConfiguration={gitConfiguration} onCompletion={onCompletion} setClearAlert={setClearAlert} clearAlert={clearAlert} />
            </Grid>}

            <Grid item xs={12} >
                <BackupRestore customStyle={{paddingTop: '0'}} browserTabTitle={browserTabTitle}  blueprintId={blueprintId} setClearAlert={setClearAlert} onClose={onClose}/>
            </Grid>


        </Grid>
    )
}